import Crud from '../views/Unidade/Crud'
import CrudConfigs from '../views/Unidade/CrudConfigs'
import Entity from '../views/Unidade/Add'

let routes = {
    path: '/unidades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/unidades/add',
            name: 'NewUnidade',
            component: Entity
        },
        {
            path: '/unidades/edit/:id?',
            name: 'EditUnidade',
            component: Entity
        },
        {
            path: '/unidades',
            name: 'list-unidades',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Unidades',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/unidades_config',
            name: 'list-unidade-configs',
            component: CrudConfigs,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Unidade Config',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
